import React, { useState, useEffect } from 'react'

import {
  Checkbox,
  FormGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material'
import { cloneDeep } from 'lodash'
import moment from 'moment'

import { OPERATION_TYPES } from 'utils/constants/operationTypes'
import QuestionButton from '../QuestionButton'
import styles from './styles'

export default function QuestionTwelve(props) {
  const classes = styles()

  const { questionData, saveResponses } = props
  
  const [aware, setAware] = useState(
    questionData.investments_out_of_xp?.aware === true,
  )
  const [awareAt, setAwareAt] = useState(null)
  const [hasInvestmentsOutOfXP, setHasInvestmentsOutOfXP] = useState(
    questionData.investments_out_of_xp?.has_investments_out_of_xp === true,
  )

  const [loading, setLoading] = useState(false)

  const [edited, setEdited] = useState(false)
  const [saved, setSaved] = useState(questionData.has_answer)

  const handleInitializeState = (data) => {
    setAware(data.investments_out_of_xp?.aware === true)
    setAwareAt(data.investments_out_of_xp?.confirmed_being_aware_at || null)
    setHasInvestmentsOutOfXP(
      data.investments_out_of_xp?.has_investments_out_of_xp === true,
    )
  }

  const handleAware = (event) => {
    setAware(event.target.checked)
    setAwareAt(moment().format('YYYY-MM-DDThh:mm:ss'))
  }

  const handleRadioChange = (event) => {
    setHasInvestmentsOutOfXP(event.target.value === 'yes')
  }

  const saveResponse = async () => {
    const newQuestionData = cloneDeep(questionData)
    newQuestionData.has_answer = true
    newQuestionData.investments_out_of_xp = {
      aware: aware,
      confirmed_being_aware_at: awareAt,
      has_investments_out_of_xp: hasInvestmentsOutOfXP,
    }
    setLoading(true)
    await saveResponses(
      newQuestionData,
      'third_party_investments',
      !saved ? OPERATION_TYPES.CREATE : OPERATION_TYPES.UPDATE,
    )
      .then(() => {
        setSaved(true)
        setEdited(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    const isAware = questionData.investments_out_of_xp?.aware === true
    const hasInvestments =
      questionData.investments_out_of_xp?.has_investments_out_of_xp === true
    const hasChanged =
      isAware !== aware || hasInvestmentsOutOfXP !== hasInvestments
    setEdited(hasChanged)
  }, [aware, hasInvestmentsOutOfXP, questionData])

  useEffect(() => {
    handleInitializeState(questionData)
  }, [questionData])

  return (
    <div className={classes.root}>
      <div className={classes.formContainer}>
        <h3>Questão 12</h3>
        <div className={classes.form}>
          <FormControl>
            <FormLabel>
              Você possui investimentos em outras corretoras, além da XP Inc.?
              (XP, Rico e Clear){' '}
            </FormLabel>
            <RadioGroup
              row
              value={hasInvestmentsOutOfXP ? 'yes' : 'no'}
              name="hasRelations"
              onChange={handleRadioChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Sim" />
              <FormControlLabel value="no" control={<Radio />} label="Não" />
            </RadioGroup>
          </FormControl>

          {hasInvestmentsOutOfXP ? (
            <div>
              <p className={classes.justified}>
                Atenção! De acordo com a ICVM 505, art. 25 e ICVM 400, art. 55,
                as pessoas vinculadas somente podem negociar valores mobiliários
                por conta própria, direta ou indiretamente, por meio do
                intermediário ao qual estiverem vinculados, ou seja, só poderão
                operar valores mobiliários nas Corretoras do grupo XP, ou seja,
                XP, Clear ou Rico. Fique atento, pois além do AAI, são
                considerados vinculados seu cônjuge ou companheiro e filhos
                menores, e, se tratando de oferta pública, há uma ampliação do
                rol alcançando os ascendentes, tais como, os pais, avós e
                bisavós e os colaterais até o 2º grau, como irmãos.
              </p>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={aware} onChange={handleAware} />}
                  label="Declaro que estou ciente dos termos apresentados."
                />
              </FormGroup>
            </div>
          ) : null}
        </div>
      </div>

      <div className={classes.buttonsContainer}>
        <QuestionButton
          variant="contained"
          onClick={saveResponse}
          loading={loading}
          saved={saved}
          edited={edited}
          disabled={(hasInvestmentsOutOfXP && !aware) || (saved && !edited)}
        />
      </div>
    </div>
  )
}
